import api from "../../plugins/api";

const selectCreditAppeal = ({ appealId, offerType }) => {
  return api.post('/api/creditPlatform/selectCreditAppeal', { appealId, offerType, actual_choice: true });
};

export default selectCreditAppeal;
